<!-- <app-drop-down-single-con-id [data]="usuarioEstados"
                      (elementoSeleccionado)="filterEstado($event)"
                      [valorPreSeleccionado]="usuarioEstados[0]"
                      [width]="'200px'"
                      [height]="'30px'"></app-drop-down-single-con-id> -->

<app-drop-down-universal-sqp [listaDesplegable]="usuarioEstados"
                             [tituloDropDown]="'Estados'"
                             (seleccionItemSingleOut)="filterEstado($event)"
                             [modo]="'single'"
                             [selectedBackgroundColor]="'var(--sqp-yellow1)'"
                             [optionHoverBackgroundColor]="'var(--sqp-yellow2)'"
                             [mostrarTooltipTituloLista]="true"
                             [mostrarIdEnLabel]="false"
                             [permitirQuitarFiltro]="false"
                             [mostrarBuscador]="false"
                             [anchuraDesplegable]="200"
                              ></app-drop-down-universal-sqp>
